import { PDFPageProxy } from "pdfjs-dist";

export const getHeightFromView = (pages: PDFPageProxy[]) => (
  pages.map(({ view }: PDFPageProxy) => `${(view[3] / view[2] * 100).toFixed(2)}%`)
);
